import { useEffect } from 'react';
import { useAppDispatch } from '../app/hooks';
import { orderPreparationActions } from '../slices/order-preparation-slice';
import { flushOutputCountUpload } from '../xml/output-count-upload-queue';

/**
 * 入稿画面の離脱時クリーンアップ。
 * 数量変更のデバウンス送信が未完了なら送り切り(変更の取りこぼし防止)、選択状態をリセットする。
 */
export const useOrderPreparationCleanup = (shopOrderId: string) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    return () => {
      flushOutputCountUpload(shopOrderId);
      dispatch(orderPreparationActions.resetSelectedOrderId());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
